import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d191171a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["readonly", "value"];
const _hoisted_2 = { class: "vdpInnerWrap" };
const _hoisted_3 = { class: "vdpHeader" };
const _hoisted_4 = ["title", "disabled"];
const _hoisted_5 = ["disabled", "title"];
const _hoisted_6 = { class: "vdpPeriodControls" };
const _hoisted_7 = { class: "vdpPeriodControl" };
const _hoisted_8 = ["value"];
const _hoisted_9 = { class: "vdpPeriodControl" };
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "vdpTable" };
const _hoisted_12 = { class: "vdpHeadCellContent" };
const _hoisted_13 = ["data-id", "onClick"];
const _hoisted_14 = { class: "vdpCellContent" };
const _hoisted_15 = {
    key: 0,
    class: "vdpTimeControls"
};
const _hoisted_16 = { class: "vdpTimeCaption" };
const _hoisted_17 = { class: "vdpTimeUnit" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_19 = ["disabled", "value"];
const _hoisted_20 = {
    key: 0,
    class: "vdpTimeSeparator"
};
const _hoisted_21 = {
    key: 1,
    class: "vdpTimeUnit"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_23 = ["disabled", "value"];
const _hoisted_24 = {
    key: 2,
    class: "vdpTimeSeparator"
};
const _hoisted_25 = {
    key: 3,
    class: "vdpTimeUnit"
};
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_27 = ["disabled", "value"];
const _hoisted_28 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vdpComponent", { vdpWithInput: _ctx.hasInputElement }])
    }, [
        _renderSlot(_ctx.$slots, "default", {
            open: _ctx.open,
            close: _ctx.close,
            toggle: _ctx.toggle,
            inputValue: _ctx.inputValue,
            processUserInput: _ctx.processUserInput,
            valueToInputFormat: _ctx.valueToInputFormat
        }, () => [
            (_ctx.hasInputElement)
                ? (_openBlock(), _createElementBlock("input", _mergeProps({
                    key: 0,
                    class: "border rounded-lg font-medium text-sm w-full focus:ring-curious-blue-500 focus:border-curious-blue-500 border-gray-300 p-[10px] mt-[1px]",
                    type: "text"
                }, _ctx.inputAttributes, {
                    readonly: _ctx.isReadOnly,
                    value: _ctx.inputValue,
                    onInput: _cache[0] || (_cache[0] = ($event) => { var _a; return (_ctx.editable && _ctx.processUserInput((_a = $event === null || $event === void 0 ? void 0 : $event.target) === null || _a === void 0 ? void 0 : _a.value)); }),
                    onFocus: _cache[1] || (_cache[1] = ($event) => (_ctx.editable && _ctx.open())),
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.editable && _ctx.open()))
                }), null, 16, _hoisted_1))
                : _createCommentVNode("", true)
        ], true),
        _createVNode(_Transition, { name: "vdp-toggle-calendar" }, {
            default: _withCtx(() => [
                (_ctx.opened)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["vdpOuterWrap", [_ctx.positionClass, { vdpFloating: _ctx.hasInputElement }]]),
                        ref: "outerWrap",
                        onClick: _cache[14] || (_cache[14] =
                            //@ts-ignore
                            (...args) => (_ctx.closeViaOverlay && _ctx.closeViaOverlay(...args)))
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("header", _hoisted_3, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["vdpArrow vdpArrowPrev", { vdpArrowDisabled: _ctx.isNavButtonDisabled }]),
                                    title: _ctx.prevMonthCaption,
                                    type: "button",
                                    disabled: _ctx.isNavButtonDisabled,
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.incrementMonth(-1)))
                                }, _toDisplayString(_ctx.prevMonthCaption), 11, _hoisted_4),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["vdpArrow vdpArrowNext", { vdpArrowDisabled: _ctx.isNavButtonDisabled }]),
                                    type: "button",
                                    disabled: _ctx.isNavButtonDisabled,
                                    title: _ctx.nextMonthCaption,
                                    onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.incrementMonth(1)))
                                }, _toDisplayString(_ctx.nextMonthCaption), 11, _hoisted_5),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        (_openBlock(), _createElementBlock("button", {
                                            class: _normalizeClass(_ctx.directionClass),
                                            key: _ctx.currentPeriod.month,
                                            type: "button"
                                        }, _toDisplayString(_ctx.months[_ctx.currentPeriod.month]), 3)),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.currentPeriod.month) = $event))
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, index) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    value: index,
                                                    key: month
                                                }, _toDisplayString(month), 9, _hoisted_8));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, _ctx.currentPeriod.month]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        (_openBlock(), _createElementBlock("button", {
                                            class: _normalizeClass(_ctx.directionClass),
                                            key: _ctx.currentPeriod.year,
                                            type: "button"
                                        }, _toDisplayString(_ctx.currentPeriod.year), 3)),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.currentPeriod.year) = $event))
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearRange, (year) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    value: year,
                                                    key: year
                                                }, _toDisplayString(year), 9, _hoisted_10));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, _ctx.currentPeriod.year]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("table", _hoisted_11, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdaysSorted, (weekday, weekdayIndex) => {
                                            return (_openBlock(), _createElementBlock("th", {
                                                class: "vdpHeadCell",
                                                key: weekdayIndex
                                            }, [
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(weekday), 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                (_openBlock(), _createElementBlock("tbody", {
                                    key: _ctx.currentPeriod.year + '-' + _ctx.currentPeriod.month,
                                    class: _normalizeClass(_ctx.directionClass)
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPeriodDates, (week, weekIndex) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            class: "vdpRow",
                                            key: weekIndex
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (item) => {
                                                return (_openBlock(), _createElementBlock("td", {
                                                    class: _normalizeClass(["vdpCell", {
                                                            selectable: _ctx.editable && !item.disabled && !item.outOfRange,
                                                            selected: item.selected,
                                                            disabled: item.disabled,
                                                            today: item.today,
                                                            outOfRange: item.outOfRange,
                                                        }]),
                                                    "data-id": item.dateKey,
                                                    key: item.dateKey,
                                                    onClick: ($event) => (_ctx.editable && _ctx.selectDateItem(item))
                                                }, [
                                                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.date.getDate()), 1)
                                                ], 10, _hoisted_13));
                                            }), 128))
                                        ]));
                                    }), 128))
                                ], 2))
                            ]),
                            (_ctx.pickTime && _ctx.currentTime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.setTimeCaption), 1),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("pre", null, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.currentTime.hoursFormatted), 1),
                                            _hoisted_18
                                        ]),
                                        _createElementVNode("input", {
                                            type: "number",
                                            pattern: "\\d*",
                                            class: "vdpHoursInput",
                                            onInput: _cache[7] || (_cache[7] = _withModifiers(
                                            //@ts-ignore
                                            (...args) => (_ctx.inputHours && _ctx.inputHours(...args)), ["prevent"])),
                                            onFocusin: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => (_ctx.onTimeInputFocus && _ctx.onTimeInputFocus(...args))),
                                            disabled: !_ctx.editable,
                                            value: _ctx.currentTime.hoursFormatted
                                        }, null, 40, _hoisted_19)
                                    ]),
                                    (_ctx.pickMinutes)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, ":"))
                                        : _createCommentVNode("", true),
                                    (_ctx.pickMinutes)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("pre", null, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.currentTime.minutesFormatted), 1),
                                                _hoisted_22
                                            ]),
                                            (_ctx.pickMinutes)
                                                ? (_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    type: "number",
                                                    pattern: "\\d*",
                                                    class: "vdpMinutesInput",
                                                    onInput: _cache[9] || (_cache[9] = ($event) => (_ctx.inputTime('setMinutes', $event))),
                                                    onFocusin: _cache[10] || (_cache[10] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.onTimeInputFocus && _ctx.onTimeInputFocus(...args))),
                                                    disabled: !_ctx.editable,
                                                    value: _ctx.currentTime.minutesFormatted
                                                }, null, 40, _hoisted_23))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.pickSeconds)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, ":"))
                                        : _createCommentVNode("", true),
                                    (_ctx.pickSeconds)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            _createElementVNode("pre", null, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.currentTime.secondsFormatted), 1),
                                                _hoisted_26
                                            ]),
                                            (_ctx.pickSeconds)
                                                ? (_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    type: "number",
                                                    pattern: "\\d*",
                                                    class: "vdpSecondsInput",
                                                    onInput: _cache[11] || (_cache[11] = ($event) => (_ctx.inputTime('setSeconds', $event))),
                                                    onFocusin: _cache[12] || (_cache[12] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.onTimeInputFocus && _ctx.onTimeInputFocus(...args))),
                                                    disabled: !_ctx.editable,
                                                    value: _ctx.currentTime.secondsFormatted
                                                }, null, 40, _hoisted_27))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.use12HourClock)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 4,
                                            type: "button",
                                            class: "vdp12HourToggleBtn",
                                            disabled: !_ctx.editable,
                                            onClick: _cache[13] || (_cache[13] = ($event) => { var _a; return (_ctx.set12HourClock(((_a = _ctx.currentTime) === null || _a === void 0 ? void 0 : _a.isPM) ? 'AM' : 'PM')); })
                                        }, _toDisplayString(_ctx.currentTime.isPM ? 'PM' : 'AM'), 9, _hoisted_28))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 2))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ], 2));
}
